import { createRouter, createWebHashHistory } from "vue-router";
import ConfigPage from "@/views/config/ConfigPage.vue";
import StructureView from "@/views/config/StructureView.vue";
import MachinesView from "@/views/config/MachinesView.vue";
import FBSstruktureView from "@/views/config/FBSstruktureView.vue";
import HomeView from "@/views/logbook/HomeView.vue";
import ItemLogbook from "@/views/logbook/ItemLogbook.vue";
import DemoConfigStruct from "@/views/misc/DemoConfigStruct.vue";
import DemoConfigEditLogbook from "@/views/misc/DemoConfigEditLogbook.vue";
import NoAccessPage from "@/NoAccessPage.vue";

const routes = [
  {
    path: "/",
    name: "Logbook",
    component: HomeView,
    meta: {
      title: "Hourly Production Logbook",
      requiresAuth: true,
      role: ["admin", "user"],
    },
  },
  {
    path: "/logbook/:id",
    name: "LogbookDetail",
    component: ItemLogbook,
    meta: {
      title: "Hourly Production Logbook | Logbook detail",
      requiresAuth: true,
      role: ["admin", "user"],
    },
  },
  {
    path: "/config",
    name: "config",
    component: ConfigPage,
    meta: {
      title: "Hourly Production Logbook - Configurator",
      requiresAuth: true,
      role: "admin",
    },
  },
  {
    path: "/machines",
    name: "machines",
    component: MachinesView,
    meta: {
      title: "Hourly Production Logbook - Machines",
      requiresAuth: true,
      role: "admin",
    },
  },
  {
    path: "/logbooks-config",
    name: "customFields",
    component: DemoConfigStruct,
    meta: {
      title: "Hourly Production Logbook - Custom Fields",
      requiresAuth: true,
      role: "admin",
    },
  },
  {
    path: "/logbooks",
    name: "logbooks",
    component: StructureView,
    meta: {
      title: "Hourly Production Logbook - Logbooks",
      requiresAuth: true,
      role: "admin",
    },
  },
  {
    path: "/mapping",
    name: "mapping",
    component: FBSstruktureView,
    meta: {
      title: "Hourly Production Logbook - Mapping",
      requiresAuth: true,
      role: "admin",
    },
  },
  {
    path: "/demoedit/:logbookid",
    name: "demoedit",
    component: DemoConfigEditLogbook,
    meta: {
      title: "xd-edit",
      requiresAuth: true,
      role: "admin",
    },
    props: true,
  },
  {
    path: "/no-access",
    name: "noAccess",
    component: NoAccessPage,
    meta: {
      title: "No Access",
    },
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

router.beforeEach((to, from, next) => {
  document.title = `${to.meta.title}`;

  const msalApp = window.msalApp;
  const account = msalApp.getActiveAccount();

  if (account) {
    const groupsProxy = account.idTokenClaims?.groups || [];
    const groups = groupsProxy.slice();
    const userRole = groups.includes(process.env.VUE_APP_ADMIN_ROLEID)
      ? "admin"
      : groups.includes(process.env.VUE_APP_USER_ROLEID)
      ? "user"
      : "none";

    // 🔒 Restrict access based on role
    if (to.meta.requiresAuth) {
      if (Array.isArray(to.meta.role)) {
        if (!to.meta.role.includes(userRole)) {
          return next("/no-access");
        }
      } else if (to.meta.role && to.meta.role !== userRole) {
        return next("/no-access");
      }
    }

    if (userRole !== "none" && to.path === "/no-access") {
      return next("/");
    }

    next();
  }
});

export default router;
